module.exports = __webpack_public_path__ + "static/media/What_does_10g_of_carbohydrate_look_like.f66fee64.png";